import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatProductCategoryModel } from 'src/app/model/cat-product-category.model';
import { CatalogModel, CatHybridCommissionSchema, SaveConfigHybridRequest } from 'src/app/model/other-catalogs-models';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { CatHybridCommissionSchemaService } from 'src/app/services/cat-hybrid-commission-schema.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';

@Component({
  selector: 'app-modal-new-hybrid',
  templateUrl: './modal-new-hybrid.component.html',
  styleUrls: ['./modal-new-hybrid.component.css']
})
export class ModalNewHybridComponent implements OnInit {
  @Input() category:CatProductCategoryModel;
  @Input() page:string;
  @Input() mode:string;

 
  now = new Date();
  commissionSchema: CatalogModel [] = [];
  SchemaName: string; 
  
    public viewStatus=1;

    schemaIdList: number []= [];

    hybridComissionSchema: SaveConfigHybridRequest = {catHybridCommissionSchema:{},schemaIdList:{}} as SaveConfigHybridRequest;
    
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  constructor(private otherCatalogService: OtherCatalogsService,
    private productCategoryService:CatCategoryProductService,
    private catHybridComissionService:CatHybridCommissionSchemaService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }

  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: false,
    searching :false,
    dom:'<"row"<"col"l><"col"<"text-center">><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    //buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:false
    ,
    pageLength: 5,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  ngOnInit() {
    this.getCatalogs();
    console.log(this.now.toISOString());
  }
  onCheck(e) {
    if (!this.schemaIdList.includes(e)) {
      this.schemaIdList.push(e);
    } else {
      var index = this.schemaIdList.indexOf(e);
      if (index > -1) {
        this.schemaIdList.splice(index, 1);
      }
    }
    console.log(this.schemaIdList);
  }
  

  

  toggleActive=()=> this.category.activeId=!this.category.activeId;


  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar un nombre para el nuevo esquema hibrido.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=(   )=> {
    console.log(this.SchemaName);
   
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion


      this.hybridComissionSchema.catHybridCommissionSchema.hybridName=this.SchemaName.toUpperCase();
      this.hybridComissionSchema.catHybridCommissionSchema.userId = Number(localStorage.getItem('token'));
      this.hybridComissionSchema.catHybridCommissionSchema.createDate=this.now.toISOString();
      this.hybridComissionSchema.catHybridCommissionSchema.activeId = 1; 
      this.hybridComissionSchema.schemaIdList= this.schemaIdList;
      this.catHybridComissionService.save(this.hybridComissionSchema)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('El Esquema Hibrido Se Guardó Con Éxito');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar el esquema.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll('cancel');



  // HELPERS
  descriptionError=()=> !this.SchemaName || this.SchemaName.trim()==='';

  getCatalogs=()=> {
    this.otherCatalogService.getListSchema()
      .pipe(
        tap((resp:any)=> {
          this.commissionSchema=resp.data;
          console.log(this.commissionSchema);
          this.viewStatus=1;
        }),
        catchError(error=> {
          this.viewStatus=-1;
          return of(this.toastr.error('OCURRIÓ UN ERROR AL OBTENER LOS ESQUEMAS PRINCIPALES'));
        })
      )
      .subscribe();
  }

}
